import { YjsEditor } from '@slate-yjs/core';
import { Editor } from 'slate';

import { EDITOR_TO_LOCAL_CHANGES_IN_SLATE_TICK } from './constants';

export type CollaborationRequiredEditor = Editor;

export type CollaborationEditor = YjsEditor &
  CollaborationRequiredEditor & {
    __collaborationEditor: true;
    isLocalModificationOrigin: (origin: unknown) => boolean;
  };

export const CollaborationEditor = {
  ...YjsEditor,

  hasLocalChangesInSlateTick(editor: CollaborationEditor): boolean {
    return EDITOR_TO_LOCAL_CHANGES_IN_SLATE_TICK.get(editor) ?? false;
  },

  isCollaborationEditor(v: unknown): v is CollaborationEditor {
    return Editor.isEditor(v) && '__collaborationEditor' in v && v.__collaborationEditor === true;
  },

  isLocalModification(editor: CollaborationEditor): boolean {
    return editor.isLocalModificationOrigin(CollaborationEditor.origin(editor));
  },
};
